export const toast = 'toast';
export const toastText = 'toast__text';
